<script>
    import { db } from './firebase';
    import { collectionData } from 'rxfire/firestore';
    import { startWith } from 'rxjs/operators';
    import { month2Human } from './util';

    export let uid;

    const query =
        db
            .collection('families')
            .where('people.uid', '==', uid);
    const familiesStream =
        collectionData(query, 'id')
            .pipe(startWith([]));
</script>

{#await $familiesStream}
    loading...
{:then families}
    {#if families.length}
        {#each families as family (family.id)}
            {family.id}
        {/each}
    {:else}
        Vypadá to, že zatím v žádné rodině nejste :(
    {/if}
{/await}

